import { fetchSearchPrioritize } from '@gn-audio/core/api/product-catalogue/fetch-search-prioritize';
import { ISearchItem, ISearchParameters, ISearchResults } from '@gn-audio/core/api/product-catalogue/models';
import { pageSize } from '../Constants';

export abstract class TopNavigationSearchResults {
  protected readonly filterQuery: string;

  constructor() {
    const filterElement: Element | null = document.querySelector('.filter-sync-model');
    this.filterQuery = filterElement?.innerHTML || '';
    filterElement?.remove();
  }

  public searchContainerToggle(selector: string, show?: boolean) {
    const container: Element | null = document.querySelector(selector);
    if (!container) {
      return;
    }

    if (show) {
      container.classList.remove('element-hidden');
    } else {
      container.classList.add('element-hidden');
    }
  }

  public addStyleClass(selector: string, className: string) {
    document.querySelectorAll(selector)
      .forEach((x: Element) => { x.classList.add(className); });
  }

  public updateProductSearch(currentSearchPhrase: string, page = 1): Promise<ISearchResults<ISearchItem>> {
    const params: ISearchParameters = {
      filter: this.filterQuery,
      orderBy: '',
      search: currentSearchPhrase,
      skip: pageSize * Math.max(page - 1, 0),
      top: pageSize,
    };

    return fetchSearchPrioritize(params);
  }
}
